import React, { forwardRef } from 'react';
import { iconList } from './iconList';
import { StyledSvgIcon } from './SvgIconUI';
import { ISvgIconProps } from './types';

const SvgIcon = forwardRef<SVGSVGElement, ISvgIconProps>(
  (
    {
      name,
      onClick,
      isActive,
      isHoverable,
      activeColor,
      isDisabled,
      customFill,
      ...props
    },
    ref,
  ) => (
    <StyledSvgIcon
      {...props}
      ref={ref}
      as={iconList[name]}
      onClick={isDisabled ? undefined : onClick}
      $isInteractive={isHoverable}
      $isDisabled={isDisabled}
      $isActive={isActive}
      $activeColor={activeColor}
      $customFill={customFill || props.fill}
    />
  ),
);

export default SvgIcon;
